/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Task_UpdatedInputs */

const cs_event_task_updated = /** @type {(inputs: Event_Task_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Úkol aktualizován`)
};

const en_event_task_updated = /** @type {(inputs: Event_Task_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task updated`)
};

/**
* | output |
* | --- |
* | "Task updated" |
*
* @param {Event_Task_UpdatedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const event_task_updated = /** @type {((inputs?: Event_Task_UpdatedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Task_UpdatedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_event_task_updated(inputs)
	return cs_event_task_updated(inputs)
});